<script>
    import { FilterFieldMixin } from '@y7k/component-filterable-list';
    /**
     *
     */
    export default {
        mixins: [
            FilterFieldMixin,
        ],

        props: ['options'],

        computed: {
            currentOption() {
                return this.options.find((option) => {
                    return `${option.value}` === `${this.value}`;
                });
            },
        },

        methods: {
            goToLast() {
                let index = this.options.indexOf(this.currentOption) - 1;
                if (index < 0) index = 0;
                this.$emit('input', this.options[index].value);
            },
            goToNext() {
                let index = this.options.indexOf(this.currentOption) + 1;
                if (index > this.options.length - 1) index = this.options.length - 1;
                this.$emit('input', this.options[index].value);
            },
        },
    };
</script>

<template>
    <div
        class="filterableList-filterItem"
        v-show="isVisible"
    >

        <div class="incrementer">
            <button
                class="incrementer-buttonLast"
                @click="goToLast"
            >

            </button>
            <div class="incrementer-currentOption">
                {{ currentOption ? currentOption.label : '' }}
            </div>
            <button
                class="incrementer-buttonNext"
                @click="goToNext"
            >

            </button>
        </div>

    </div>
</template>
